/**
 * Shared constants + helpers for dashboard sub-components.
 * Colocated under `components/dashboard/` so Phase B.6 split sites can all
 * import from one stable place.
 */

// Donut / pie slice palette used by Budget + Spending-by-Category charts.
// May 2026 rebrand — pinks/beiges/mauves only, in descending visual weight
// so the largest category lands on the brand's flagship dusty rose.
export const DASHBOARD_PALETTE = [
  '#D1B0AB', // dusty rose (brand accent)
  '#9D8089', // deeper mauve
  '#D4B896', // warm beige
  '#C5B0BA', // lavender mauve
  '#BFA88A', // khaki beige
  '#CCC2BC', // taupe
];

/**
 * Consistent currency formatting across every dashboard card.
 * Safe for null/undefined inputs — returns "$0" or equivalent.
 */
export const formatCurrency = (amount, currency = 'USD') =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount || 0);
